import React, { useState } from 'react';

const directions = ['', 'Long', 'Short'];

function TradeForm({ accounts, trades, setTrades }) {
  const [tradeAccount, setTradeAccount] = useState('');
  const [tradeDate, setTradeDate] = useState('');
  const [tradeInstrument, setTradeInstrument] = useState('');
  const [tradeSize, setTradeSize] = useState('');
  const [tradeDirection, setTradeDirection] = useState('');
  const [entryPrice, setEntryPrice] = useState('');
  const [exitPrice, setExitPrice] = useState('');
  const [tradeFee, setTradeFee] = useState('');

  // 获取今天日期（yyyy-mm-dd）
  const today = new Date().toISOString().split('T')[0];

  const handleAddTrade = () => {
    const size = parseFloat(tradeSize);
    const entry = parseFloat(entryPrice);
    const exit = parseFloat(exitPrice);
    const fee = parseFloat(tradeFee) || 0;
    if (!tradeAccount || !tradeDate || !tradeInstrument.trim() || isNaN(size) || size <= 0 || !tradeDirection || isNaN(entry) || isNaN(exit)) {
      alert('请填写所有交易记录字段，且数值必须有效！');
      return;
    }
    const profit = tradeDirection === 'Long'
      ? (exit - entry) * size - fee
      : (entry - exit) * size - fee;
    const newTrade = {
      account: tradeAccount,
      date: tradeDate,
      instrument: tradeInstrument.trim(),
      size,
      direction: tradeDirection,
      entry,
      exit,
      fee,
      profit
    };
    setTrades([newTrade, ...trades]);
    setTradeAccount('');
    setTradeDate('');
    setTradeInstrument('');
    setTradeSize('');
    setTradeDirection('');
    setEntryPrice('');
    setExitPrice('');
    setTradeFee('');
    alert('交易记录添加成功！');
  };

  return (
    <div className="section">
      <h2>添加交易记录</h2>
      <div>账户名称
        <select value={tradeAccount} onChange={e => setTradeAccount(e.target.value)}>
          <option value="">请选择账户</option>
          {accounts.map(acc => (
            <option key={acc.name} value={acc.name}>{acc.name}</option>
          ))}
        </select>
      </div>
      <div>交易日期 <input type="date" value={tradeDate} onChange={e => setTradeDate(e.target.value)} max={today} /></div>
      <div>交易品种 <input type="text" value={tradeInstrument} onChange={e => setTradeInstrument(e.target.value)} placeholder="请输入交易品种" /></div>
      <div>仓位大小 <input type="text" value={tradeSize} onChange={e => setTradeSize(e.target.value)} placeholder="请输入仓位大小" /></div>
      <div>开仓方向
        <select value={tradeDirection} onChange={e => setTradeDirection(e.target.value)}>
          {directions.map(dir => (
            <option key={dir} value={dir}>{dir === '' ? '请选择' : dir}</option>
          ))}
        </select>
      </div>
      <div>入场价格 <input type="text" value={entryPrice} onChange={e => setEntryPrice(e.target.value)} placeholder="请输入入场价格" /></div>
      <div>出场价格 <input type="text" value={exitPrice} onChange={e => setExitPrice(e.target.value)} placeholder="请输入出场价格" /></div>
      <div>手续费 <input type="text" value={tradeFee} onChange={e => setTradeFee(e.target.value)} placeholder="请输入手续费" /></div>
      <button onClick={handleAddTrade}>添加交易</button>
    </div>
  );
}

export default TradeForm; 